// Retenciones sugeridas (editables) según el tipo de comprobante.
// E41: 100% del ITBIS facturado + ISR sobre servicios de personas físicas
// (10% hasta 30-06-2026; 15% desde 01-07-2026 por Ley 30-26). E47: 27% ISR sobre pagos al exterior.
export const isrRate = (date) => ((date || new Date().toISOString()).slice(0, 10) >= "2026-07-01" ? 0.15 : 0.10);

export function suggestRetentions(docType, { itbis = 0, servicesSubtotal = 0, subtotal = 0, date }) {
  const r2 = (n) => Math.round(n * 100) / 100;
  if (docType === "E41") return { itbis_retenido: r2(itbis), isr_retenido: r2(servicesSubtotal * isrRate(date)) };
  if (docType === "E47") return { itbis_retenido: 0, isr_retenido: r2(subtotal * 0.27) };
  return { itbis_retenido: 0, isr_retenido: 0 };
}

export const TIPOS_GASTO_606 = [
  { value: "01", label: "01 · Gastos de personal" },
  { value: "02", label: "02 · Trabajos, suministros y servicios" },
  { value: "03", label: "03 · Arrendamientos" },
  { value: "04", label: "04 · Gastos de activos fijos" },
  { value: "05", label: "05 · Gastos de representación" },
  { value: "06", label: "06 · Otras deducciones admitidas" },
  { value: "07", label: "07 · Gastos financieros" },
  { value: "08", label: "08 · Gastos extraordinarios" },
  { value: "10", label: "10 · Adquisiciones de activos" },
  { value: "11", label: "11 · Gastos de seguros" },
];
